import { useState, useCallback, useRef } from 'react';
export const useCarousel = ({ totalSlides, slideToShow, onChange, }) => {
    const [indexActive, setIndexActive] = useState(0);
    const [slideWidth, setSlideWidth] = useState(0);
    const containerRef = useRef(null);
    const measuredContainerRef = useCallback(node => {
        if (node !== null) {
            const containerWidth = node.getBoundingClientRect().width;
            const calculateSlideWidth = slideToShow
                ? containerWidth / slideToShow
                : containerWidth;
            setSlideWidth(calculateSlideWidth);
            containerRef.current = node;
            return containerRef;
        }
        return null;
    }, [slideToShow]);
    const slideIsActive = (idx) => indexActive === idx;
    const handlerScroll = (index) => {
        if (!containerRef.current)
            return;
        const containerWidth = containerRef.current.offsetWidth;
        const int = Math.floor(slideToShow);
        const scrollTo = ((containerWidth * int) / slideToShow) * index;
        containerRef.current.scrollTo({
            left: scrollTo,
            behavior: 'smooth',
        });
        onChange && onChange(indexActive);
    };
    const goToPrevSlide = () => {
        if (indexActive === 0)
            return;
        handlerScroll(indexActive - 1);
    };
    const goToNextSlide = () => {
        if (!containerRef.current)
            return;
        const slideActived = indexActive + 1;
        if (slideActived === totalSlides)
            return;
        handlerScroll(indexActive + 1);
    };
    const goToFirstSlide = () => {
        handlerScroll(0);
    };
    const goToLastSlide = () => {
        handlerScroll(totalSlides - 1);
    };
    const handlerOnKeyDown = (event) => {
        const { key } = event;
        if (key === 'Home' || key === 'PageUp')
            goToFirstSlide();
        // Home or PageUp
        else if (key === 'End' || key === 'PageDown')
            goToLastSlide();
        // End or PageDown
        else if (key === 'ArrowLeft' || key === 'ArrowUp')
            goToPrevSlide();
        // Left or Up
        else if (key === 'ArrowDown' || key === 'ArrowRight')
            goToNextSlide();
        // Right or Down
        else
            return;
    };
    const handlerOnScroll = (event) => {
        const { currentTarget } = event;
        const { scrollLeft, scrollWidth } = currentTarget;
        const scrollPerPage = scrollWidth / totalSlides;
        const calculatePagination = scrollLeft / scrollPerPage;
        const currentIndex = calculatePagination > 0 && calculatePagination < 1
            ? 1
            : Math.round(calculatePagination);
        if (currentIndex !== indexActive) {
            setIndexActive(currentIndex);
        }
    };
    return {
        slideActiveIndex: indexActive,
        goToNextSlide,
        goToPrevSlide,
        handlerOnKeyDown,
        slideWidth,
        measuredContainerRef,
        slideIsActive,
        handlerOnScroll,
    };
};
//# sourceMappingURL=hook.js.map